import store from '@/store'

export default [
  {
    path: '/attendance-shifts',
    name: 'attendance-shift',
    component: () => import('@/pages/attendance-shift/index.vue')
  },
  {
    path: '/attendance-shifts/create',
    name: 'attendance-shift-create',
    component: () => import('@/pages/attendance-shift/create.vue')
  },
  {
    path: '/attendance-shifts/:id',
    name: 'attendance-shift-edit',
    component: () => import('@/pages/attendance-shift/edit.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('attendanceShift/find', to.params.id)
      next()
    }
  }
]
